// extracted by mini-css-extract-plugin
module.exports = {"ActionAssetItem__asset-menu-action__1wmM7":"ActionAssetItem__asset-menu-action__1wmM7","ActionAssetItem__label__3Nv--":"ActionAssetItem__label__3Nv--"};